import React, { useEffect, useState } from "react";
import classNames from "classnames";

/**
 * @param {{
 *   field?: { name?: string; label?: string } | null;
 *   name?: string;
 *   label?: string;
 *   options: Array<{ label: string; value?: any; suffix?: string }>;
 *   onChange: (event: any, fieldName: string, fieldValue: any) => void;
 *   formState?: any[];
 * }} props
 */
const MultiSelectDropdown = ({ field = null, name, label, options, onChange, formState=[] }) => {
    const [checkedValues, setCheckedValues] = useState([]);
    const fieldName = name || field?.name || "";
    const fieldLabel = label || field?.label || "";

    // Handle individual checkbox toggle
    const handleCheckboxChange = (label, value, isChecked) => {
        let updatedValues;
        if (isChecked) {
            updatedValues = [...checkedValues, {label: label, value: value}];
        } else {
            updatedValues = checkedValues.filter((obj) => obj.value !== value);
        }
        setCheckedValues(updatedValues);

        extractValues(updatedValues);
    };

    // Handle "select all" checkbox
    const handleSelectAll = (isChecked) => {
        const allValues = options.map((opt) => { return {label: opt.label, value: opt.value}});
        const updatedValues = isChecked ? allValues : [];
        setCheckedValues(updatedValues);

        extractValues(updatedValues);
    };

    const extractValues = (updatedValues) =>{
        const values = updatedValues.map(obj=> obj.value);
        onChange({ target: { name: fieldName, value: values } }, fieldName, values);
    }

    const showCheckedValues = () => {
        if (checkedValues.length === 0) return;
        if (checkedValues.length <= 4) return checkedValues.map(obj=>obj.label).join(", ");
        return `${checkedValues.slice(0, 4).map(obj=>obj.label).join(", ")}, +${checkedValues.length - 4} more`
    }

    useEffect(()=> {
        if(formState && Array.isArray(formState)){
            const defaultValues = options.filter(opt=> formState.includes(opt.value))
            .map(opt=> { return {label: opt.label, value: opt.value}});
            setCheckedValues(defaultValues);
        }
    }, [formState]);
    // Check if all options are selected
    const isAllSelected = checkedValues.length === options.length;
    
    return (
        <div className="dropdown w-100" role="listbox">
            <button
                type="button"
                className="form-select btn border dropdown-toggle text-start overflow-x-hidden"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
            >
                <span className="pe-4">{showCheckedValues() || (`Select ${fieldLabel}`)}</span>
            </button>
            <ul className="dropdown-menu py-1 w-100 overflow-y-auto" style={{ maxHeight: "20rem" }}>
                <li className="px-3 py-2 border-bottom fs-7" role="option">
                    <div className="form-check form-check-inline">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id={`select-all-${fieldName}`}
                            checked={isAllSelected}
                            onChange={(e) => handleSelectAll(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor={`select-all-${fieldName}`}>
                            Select All
                        </label>
                    </div>
                </li>

                {options.map((opt, i) => (
                    <li role="listitem"
                        className={classNames("px-3 py-2 fs-7", { "border-bottom": i < options.length - 1 })}
                        key={opt.value}
                    >
                        <div className="form-check form-check-inline">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id={`${opt.value}-${i}`}
                                value={opt.value}
                                checked={checkedValues.map(obj=>obj.value).includes(opt.value)}
                                onChange={(e) =>
                                    handleCheckboxChange(opt.label,opt.value, e.target.checked)
                                }
                            />
                            <label className="form-check-label" htmlFor={`${opt.value}-${i}`}>
                                {opt.label} {opt.suffix && opt.suffix}
                            </label>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default MultiSelectDropdown;
